const PLUGIN_NAME = 'preview-fe';
export { PLUGIN_NAME };
//# sourceMappingURL=constants.js.map